export default __webpack_public_path__ + "static/media/start-mushroom_DE.b4672d62.png";